<div class="container-fluid p-3">
  <div class="row">
    <div class="mb-4">
      <!-- Header section with buttons and title -->
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 flex-wrap">
        <!-- Title aligned to the right on larger screens -->
        <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
          {{ 'TEST_DETAIL.LIST' | translate }}
        </h4>
        <!-- Buttons stacked on small screens -->
        <div class="d-flex flex-column flex-sm-row gap-2 flex-wrap">
          <app-button (click)="displayTest()" [label]="'BUTTONS.CREATE_TEST' | translate"
            [customClasses]="'fs-14 fg-600 py-2 px-5 btn-create-test'" [type]="'button'" />
        </div>
      </div>

      <!-- Card with data table -->
      <div class="mt-3">
        <app-tests-data />
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>